import { lazy } from "react";
import { Navigate } from "react-router-dom";
import UsersView from "../views/Users/Users.jsx";
import CreateUser from "../views/Users/CreateUser.tsx";
import CreateCategory from "../views/Categories/CreateCategory.tsx";
import EditUsers from "../views/Users/EditUser.tsx";
import CategoriesView from "../views/Categories/Categories.tsx";
import EditCategories from "../views/Categories/EditCategory.tsx";
import CoursesView from "../views/Course/Courses.tsx";
import CreateCourse from "../views/Course/CreateCourse.tsx";
import EditCourse from "../views/Course/EditCourse.tsx";
import PaymentsView from "../views/Payments/Payments.tsx";
import CreatePayment from "../views/Payments/CreatePayment.tsx";
import EditPayment from "../views/Payments/EditPayment.tsx";
import RepresentativesView from "../views/Representatives/Representatives.tsx";
import CreateRepresentative from "../views/Representatives/CreateRepresentative.tsx";
import EditRepresentative from "../views/Representatives/EditRepresentative.tsx";
import StudentsView from "../views/Students/Students.tsx";
import EditStudent from "../views/Students/EditStudent.tsx";
import CreateStudent from "../views/Students/CreateStudent.tsx";
import CreateStudentPublic from "../views/Students/CreateStudentPublic.tsx";
import Login from "../views/Login/Login.tsx";
import PrivateRoute from "./PrivateRoute/PrivateRoute.tsx";
import NoAccess from "./../views/NoAccess.tsx";
import CreateClientStudent from "./../views/Students/CreateClientStudent.tsx";
import AdminDashboard from "./../views/GihDashboards/AdminDashboard.tsx";
import StudentMonthlyPayment from "./../views/PaymentsStudents/StudentMonthlyPayment.tsx"
import SuccessMessage from "./../views/PaymentsStudents/SuccessMessage.tsx";
import InvoicesView from "../views/Invoices/Invoices.tsx";
import ValidInvoice from "../views/Invoices/ValidInvoice.tsx";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
const FullLayoutGih = lazy(() =>
  import("../layouts/FullLayout/FullLayoutGih.js")
);
const PublicLayout = lazy(() =>
  import("../layouts/FullLayout/PublicLayout.js")
);
/****End Layouts*****/

/*****Pages******/
// const Dashboard1 = lazy(() => import("../views/dashboards/Dashboard1.js"));

/*****Tables******/
const BasicTable = lazy(() => import("../views/tables/BasicTable.js"));

// form elements
const ExAutoComplete = lazy(() =>
  import("../views/FormElements/ExAutoComplete.js")
);
const ExButton = lazy(() => import("../views/FormElements/ExButton.js"));
const ExCheckbox = lazy(() => import("../views/FormElements/ExCheckbox.js"));
const ExRadio = lazy(() => import("../views/FormElements/ExRadio.js"));
const ExSlider = lazy(() => import("../views/FormElements/ExSlider.js"));
const ExSwitch = lazy(() => import("../views/FormElements/ExSwitch.js"));
// form layouts
const FormLayouts = lazy(() => import("../views/FormLayouts/FormLayouts.js"));

/*****Routes******/

const ThemeRoutes = [
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { path: "", element: <Navigate to="login" /> },
      { path: "login", element: <Login /> },
      { path: "register", element: <CreateStudentPublic /> },
      {
        path: "monthlypayment/:studentId/:representativeId/:courseId",
        element: <StudentMonthlyPayment />,
      },
      {
        path: "success",
        element: <SuccessMessage />,
      },
      { path: "no-access", element: <NoAccess /> },
    ],
  },
  {
    path: "/admin",
    element: <FullLayoutGih />,
    children: [
      { path: "", element: <Navigate to="dashboards/dashboard1" /> },
      {
        path: "dashboards/dashboard1",
        element: (
          <PrivateRoute element={<AdminDashboard />} requiredRole="admin" />
        ),
      },

      // Users
      {
        path: "users",
        element: <PrivateRoute element={<UsersView />} requiredRole="admin" />,
      },
      {
        path: "users/createUser",
        element: <PrivateRoute element={<CreateUser />} requiredRole="admin" />,
      },
      {
        path: "users/editUser/:id",
        element: <PrivateRoute element={<EditUsers />} requiredRole="admin" />,
      },

      // Categories
      {
        path: "categories",
        element: (
          <PrivateRoute element={<CategoriesView />} requiredRole="admin" />
        ),
      },
      {
        path: "categories/createCategories",
        element: (
          <PrivateRoute element={<CreateCategory />} requiredRole="admin" />
        ),
      },
      {
        path: "categories/editCategory/:id",
        element: (
          <PrivateRoute element={<EditCategories />} requiredRole="admin" />
        ),
      },

      // Courses
      {
        path: "courses",
        element: (
          <PrivateRoute element={<CoursesView />} requiredRole="admin" />
        ),
      },
      {
        path: "courses/createCourse",
        element: (
          <PrivateRoute element={<CreateCourse />} requiredRole="admin" />
        ),
      },
      {
        path: "courses/editCourse/:id",
        element: <PrivateRoute element={<EditCourse />} requiredRole="admin" />,
      },

      // Payments
      {
        path: "payments",
        element: (
          <PrivateRoute element={<PaymentsView />} requiredRole="admin" />
        ),
      },
      {
        path: "payments/createPayment",
        element: (
          <PrivateRoute element={<CreatePayment />} requiredRole="admin" />
        ),
      },
      {
        path: "payments/editPayment/:id",
        element: (
          <PrivateRoute element={<EditPayment />} requiredRole="admin" />
        ),
      },

      // Invoices
      {
        path: "invoices",
        element: (
          <PrivateRoute element={<InvoicesView />} requiredRole="admin" />
        ),
      },
      {
        path: "invoices/validInvoice/:id",
        element: (
          <PrivateRoute element={<ValidInvoice />} requiredRole="admin" />
        ),
      },

      // Representatives
      {
        path: "representatives",
        element: (
          <PrivateRoute
            element={<RepresentativesView />}
            requiredRole="admin"
          />
        ),
      },
      {
        path: "representatives/createRepresentative",
        element: (
          <PrivateRoute
            element={<CreateRepresentative />}
            requiredRole="admin"
          />
        ),
      },
      {
        path: "representatives/editRepresentative/:id",
        element: (
          <PrivateRoute element={<EditRepresentative />} requiredRole="admin" />
        ),
      },

      // Students
      {
        path: "students",
        element: (
          <PrivateRoute element={<StudentsView />} requiredRole="admin" />
        ),
      },
      {
        path: "students/createStudent",
        element: (
          <PrivateRoute element={<CreateStudent />} requiredRole="admin" />
        ),
      },
      {
        path: "students/editStudent/:id",
        element: (
          <PrivateRoute element={<EditStudent />} requiredRole="admin" />
        ),
      },
      {
        path: "students/createstudentclient",
        element: (
          <PrivateRoute
            element={<CreateClientStudent />}
            requiredRole="client"
          />
        ),
      },
    ],
  },
  {
    path: "/theme",
    element: <FullLayout />,
    children: [
      { path: "", element: <Navigate to="dashboards/dashboard1" /> },
      { path: "dashboards/dashboard1", exact: true, element: <AdminDashboard /> },
      { path: "tables/basic-table", element: <BasicTable /> },
      { path: "form-layouts/form-layouts", element: <FormLayouts /> },
      { path: "form-elements/autocomplete", element: <ExAutoComplete /> },
      { path: "form-elements/button", element: <ExButton /> },
      { path: "form-elements/checkbox", element: <ExCheckbox /> },
      { path: "form-elements/radio", element: <ExRadio /> },
      { path: "form-elements/slider", element: <ExSlider /> },
      { path: "form-elements/switch", element: <ExSwitch /> },
    ],
  },
];

export default ThemeRoutes;
